import React from 'react';
import { getLabel } from '../../../data/labels';

export default function Legend() {
    const states = [
        {class: 'esito-v', label: getLabel('checkbet.winning_match')},
        {class: 'esito-p', label: getLabel('checkbet.losing_match')},
        {class: 'esito-nd', label: getLabel('checkbet.match_in_progress')},
        {class: 'esito-vd', label: getLabel('checkbet.match_voided')},
    ];

    return (
        <div id="checkbet-legend-container" className="mb_3">
            <table className="table table-sm | mb_3_1">
                <thead className="mb_3_1_1">
                    <tr className="mb_3_1_1_1">
                        <th scope="col" className="padding-left-10 bold | mb_3_1_1_1_1">{getLabel('checkbet.color')}</th>
                        <th scope="col" className="padding-left-10 bold | mb_3_1_1_1_2">{getLabel('checkbet.meaning')}</th>
                    </tr>
                </thead>
                <tbody className="mb_3_1_2">
                    {states.map((s,i) =>
                        <tr className="mb_3_1_2_1" key={i}>
                            <td className="padding-left-10 text-center | mb_3_1_2_1_1">
                                <span className={"d-flex align-items-center margine-dx margine-sx bold | mb_3_1_2_1_1_1 " + s.class}></span>
                            </td>
                            <td className="padding-left-10 | mb_3_1_2_1_2">{s.label}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
